export default "__VITE_ASSET__cWQvhT$l__"